import React, { useState, useEffect } from "react";
import Plot from "react-plotly.js";
import Chartgrid from "../chartgrid";
import MarketOptionS from "../options/marketoptions_strategy";
import StockPredict from "../Stock_Predict";


const OC = ({data}) => {
    return(
      <table className="option-chain">
        <thead>
          <tr>
            <th>Strike</th>
            <th>Type</th>
            <th>OI</th>
            <th>IV</th>
            <th>Delta</th>
            <th>Gamma</th>
            <th>Vega</th>
          </tr>
        </thead>
        <tbody>
          {data.options.map((opt, index) => (
            <tr key={index} style={{ background: opt.oi > 5000 ? "#f4c242" : "white" }}>
              <td>{opt.strike}</td>
              <td>{opt.type}</td>
              <td>{opt.oi}</td>
              <td>{(opt.impliedVolatility * 100).toFixed(2)}%</td>
              <td>{opt.delta.toFixed(2)}</td>
              <td>{opt.gamma.toFixed(2)}</td>
              <td>{opt.vega.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
}

const OIChangeBarChart = ({data}) => {
    console.log("CHANGE DATA",data)
    return(
      <Plot
        data={[
          {
            x: data.oi_data.map(d => d.strike),
            y: data.oi_data.map(d => d.call_oi_change),
            type: "bar",
            name: "Call OI Change",
            marker: { color: "green" },
          },
          {
            x: data.oi_data.map(d => d.strike),
            y: data.oi_data.map(d => d.put_oi_change),
            type: "bar",
            name: "Put OI Change",
            marker: { color: "red" },
          },
        ]}
        layout={{ title: "OI Change Analysis", xaxis: { title: "Strike Price" }, yaxis: { title: "OI Change" } }}
      />
    );
}


const OIBarChart = ({data}) => {
    return(
        <Plot
          data={[{
            x: data.options.map(opt => opt.strike),
            y: data.options.map(opt => opt.oi),
            type: "bar",
            marker: { color: "blue" },
          }]}
          layout={{ title: "Open Interest Distribution", xaxis: { title: "Strike Price" }, yaxis: { title: "Open Interest" } }}
        />
    );
}

const PCR = ({data}) => {
    const pcrData = data.options.reduce((acc, opt) => {
      acc[opt.strike] = (acc[opt.strike] || { calls: 0, puts: 0 });
      acc[opt.strike][opt.type === "call" ? "calls" : "puts"] += opt.oi;
      return acc;
    }, {});

    const pcrValues = Object.keys(pcrData).map(strike => ({
      strike,
      pcr: pcrData[strike].puts / (pcrData[strike].calls || 1), // Avoid division by zero
    }));

    return(
        <div>
    <Plot
      data={[{
        x: pcrValues.map(d => d.strike),
        y: pcrValues.map(d => d.pcr),
        type: "scatter",
        mode: "lines+markers",
        marker: { color: "red" },
      }]}
      layout={{ title: "Put-Call Ratio (PCR)", xaxis: { title: "Strike Price" }, yaxis: { title: "PCR Ratio" } }}
    />
      {/*    <Plot*/}
      {/*  data={[*/}
      {/*    {*/}
      {/*      x: data.options.map(opt => opt.strike),*/}
      {/*      y: data.options.map(opt => opt.oi),*/}
      {/*      type: "bar",*/}
      {/*      name: "Open Interest",*/}
      {/*      marker: { color: "blue" },*/}
      {/*    },*/}
      {/*  ]}*/}
      {/*  layout={{ title: `Max Pain at Strike: ${data.max_pain}`, xaxis: { title: "Strike Price" }, yaxis: { title: "Open Interest" } }}*/}
      {/*/>*/}
    </div>
    );
}

const GreeksIV = ({data}) => {

    return(
      <Plot
        data={[
          {
            x: data.options.map(opt => opt.delta),
            y: data.options.map(opt => opt.vega),
            text: data.options.map(opt => `Strike: ${opt.strike}`),
            mode: "markers",
            marker: { size: data.options.map(opt => opt.gamma * 5000), color: "green" },
            name: "Greeks",
          },
        ]}
        layout={{ title: "Greeks Sensitivity", xaxis: { title: "Delta" }, yaxis: { title: "Vega" } }}
      />
    );
}


const AIML = ({ stockSymbol }) => {
  const [data, setData] = useState(null);
  const subSections = ["Predictive Modelling", "Sentiment Analysis", "IV Rank & Market Regime"];//, "Trends Treemap"];
  const [activeSubTab, setActiveSubTab] = useState(subSections[0]);

  useEffect(() => {
    // fetch(`http://127.0.0.1:8000/api/stockdata/op/${stockSymbol}/`)
    //   .then((response) => response.json())
    //   .then((data) => setData(data))
    //   .catch((error) => console.error("Error fetching options data:", error));
    setData(stockSymbol)
  }, [stockSymbol]);

  // if (!data) return <p>Loading options data...</p>;


  const renderContent = () => {

    switch (activeSubTab) {
      case "Predictive Modelling":
        return (<div align={"center"} style={{height:"700px"}}>
      <StockPredict symbol={stockSymbol}/>
            </div>);
      // case "Max Pain & PCR Analysis":
      //   return data ? (<div align={"center"} style={{height:"700px"}}>
      //   <Chartgrid rows={1} cols={1} symbols={[stockSymbol]} charttype={['oi']}/>
      // <PCR data={data} />
      //           </div>): (
      //           <p>Loading data...</p>
      //         );
      // case "Greeks & IV Analysis":
      //   return data ? (<div align={"center"} style={{height:"700px"}}>
      // <GreeksIV data={data} />
      //           </div>) : (
      //           <p>Loading data...</p>
      //         );
      // case "Live Options Strategy Builder":
      //   return data ? (<div align={"center"} style={{height:"700px"}}>
      // <MarketOptionS symbol={stockSymbol} />
      //   </div>) : (
      //           <p>Loading data...</p>
      //         );
      default:
        return <div>Select a tab to view content.</div>;
    }
  };



  return (
    <div className="section-container">
        {/* Vertical Sidebar */}
      <div className="sidebar">
        {subSections.map((tab) => (
          <button
            key={tab}
            className={`side-tab ${activeSubTab === tab ? "active" : ""}`}
            onClick={() => setActiveSubTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content Display */}
      <div className="content">
        {/*<h2>{activeSubTab}</h2>*/}
        {/*<p>Displaying data for {activeSubTab}...</p>*/}
        {renderContent()}
      </div>
    </div>
  );
};

export default AIML;
